(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  const mainContent = document.getElementById('MainContent');
  const templateName = mainContent?.dataset.template ?? '';
  const isCollectionTemplate = templateName.includes('collection');

  const supportsSessionStorage = (() => {
    try {
      const testKey = '__scroll-test__';
      sessionStorage.setItem(testKey, '1');
      sessionStorage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  })();

  if (isCollectionTemplate && supportsSessionStorage) {
    const storageKey = `collection-scroll:${window.location.pathname}`;

    const restoreScrollPosition = () => {
      const storedValue = sessionStorage.getItem(storageKey);
      if (storedValue === null) return;

      const targetScroll = Number(storedValue);
      if (!Number.isFinite(targetScroll)) return;

      const applyScroll = () => {
        const scrollOptions = { top: targetScroll, left: 0, behavior: 'auto' };
        window.scrollTo(scrollOptions);
        requestAnimationFrame(() => window.scrollTo(scrollOptions));
        sessionStorage.removeItem(storageKey);
      };

      if (document.readyState === 'complete') {
        applyScroll();
      } else if (document.readyState === 'interactive') {
        requestAnimationFrame(applyScroll);
      } else {
        window.addEventListener('DOMContentLoaded', applyScroll, { once: true });
      }
    };

    const navigationEntries = typeof performance.getEntriesByType === 'function' ? performance.getEntriesByType('navigation') : [];
    const navigationType = navigationEntries.length > 0 ? navigationEntries[0].type : performance.navigation?.type;
    const cameFromBackNavigation = navigationType === 'back_forward' || navigationType === 2;

    if (cameFromBackNavigation) restoreScrollPosition();
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) restoreScrollPosition();
    });

    const shouldIgnoreProductClick = (event) =>
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey;

    document.addEventListener('click', (event) => {
      if (shouldIgnoreProductClick(event)) return;
      const target = event.target;
      if (!(target instanceof Element)) return;

      const link = target.closest('a.product-card__link');
      if (!(link instanceof HTMLAnchorElement)) return;

      let linkUrl;
      try {
        linkUrl = new URL(link.href, window.location.origin);
      } catch (error) {
        return;
      }

      if (linkUrl.origin !== window.location.origin) return;
      if (!linkUrl.pathname.includes('/products/')) return;

      sessionStorage.setItem(storageKey, String(window.scrollY));
    });
  }

  } catch(e) { console.error(e); }
})();
})();
